<template>
	<div>
		<img
			alt="logo"
			class="big-logo"
			src="../assets/logo-big.png"
		>
		<h1 style="margin-bottom: 50px">
			{{ $t('contacts.title') }}
		</h1>
		<p>{{ $t('contacts.name') }}</p>
		<p class="address-wrapper">
			<span class="title">{{ $t('contacts.urAddress') }}:</span>
			<span>{{ $t('contacts.urAddressVal') }}</span>
		</p>
		<p class="address-wrapper">
			<span class="title">{{ $t('contacts.curAddress') }}:</span>
			<span>{{ $t('contacts.curAddressVal') }}</span>
		</p>
		<p>
			<span class="title">email:</span> <a href="mailto:mail@acdcproc.com">mail@acdcproc.com</a>
		</p>
		<p>
			<span class="title">tel:</span> <a href="tel:+380966431629">+38(096) 643 16 29</a>
		</p>
	</div>
</template>

<script>
	export default {
		name: 'Contacts'
	};
</script>

<style scoped lang="less">
	p{
		margin-bottom: 10px;
	}
	a{
		color: #fa5255;
		text-decoration: none;
		a:hover{
			color: #ff0a00;
		}
	}
	span.title{
		width: 150px;
		display: inline-block;
		flex-shrink: 0;
		font-weight: 300;
	}
	.address-wrapper{
		display: flex;
		align-items: flex-start;
	}
</style>
